import { makeStyles } from '@mui/styles';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import Tooltip from 'apollo-react/components/Tooltip';
import React, { memo } from 'react';

import { LINK_TARGET } from '../../../constants/report-model-designer.constants';

const useStyles = makeStyles({
  selectCell: {
    display: 'flex',
    minWidth: 100,
    width: 200,
    '@media (max-width: 1600px)': {
      width: 180,
    },
    '@media (max-width: 1400px)': {
      width: 160,
    },
  },
});

const SelectCell = memo(({ row, column: { accessor: key } }) => {
  const classes = useStyles();

  const { fieldLists, Id, Name: entityName, parentEntityName, editRow, ParentId } = row;

  const value = row[key];

  const menuList =
    key === LINK_TARGET ? fieldLists[parentEntityName] : fieldLists[entityName] || [];

  const sortedMenuList = menuList ? menuList.sort() : [];

  const handleSelect = (e) => {
    e.target.value && editRow({ id: Id, key, value: e.target.value });
  };

  return (
    <Tooltip title={value || ''} disableFocusListener>
      <div className={classes.selectCell} key={Id}>
        <Select
          size="small"
          fullWidth
          asteriskPosition="before"
          value={value || ''}
          disabled={!ParentId && key === LINK_TARGET}
          onChange={handleSelect}
        >
          {sortedMenuList?.map((option, index) => (
            <MenuItem key={option + index} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </div>
    </Tooltip>
  );
});

export default SelectCell;
